<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TitXey/tc-custom/9781418573447.jpg?1721442173409" alt="This image is the cover for the book 10 Choices"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">10 Choices
      </h1>
      <p class="bookDescription body article font2">
        <p>Many people see their lives playing out like a movie they cannot control. They have come to feel like spectators watching a story unfold, unable to stop the stampeding consequences. They feel the die is cast, and nothing they do can alter the outcome. James MacDonald believes that is a lie. In <i>10 Choices</i> he says, while people are where they are in life because of the choices they've made, they don't have to stay there. This book is about getting beyond self-help and blame shifting and changing at the deepest and most profound level...the will.</p><p>A person's will is what he uses to choose and act. This book helps readers to discover the heights to which their wills, truly surrendered to God, can actually soar and the "10 choices" that can take them there. This impactful book will prompt readers to make <i>10 Choices</i> that are sure to change their lives forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James MacDonald
      </h2>
      
      <p class="authorDescription body article"><P>Dr. James MacDonald&#160;is founding pastor of Harvest Bible Chapel.&#160;He is the author of the bestseller&#160;I Really Want to Change...So, Help Me God&#160;and several other books.&#160;Walk in the Word&#160;is his national radio broadcast.&#160;He earned his Masters in Religion at Trinity Evangelical Divinity School and his Doctor of Ministry from Phoenix Seminary.&#160;He and his wife, Kathy, have three children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?845da6c8